module.exports = __webpack_public_path__ + "img/Picture11.14605d45.png";